import React from "react";
import { useSelector } from "react-redux";

import { Grid } from "@mui/material";

import { experienceAnalysis } from "../../../../../../store/slices/ai";
import { BackButton } from "../../BackButton";
import { MessagePanel } from "../../messagePanel/MessagePanel";
import { RegenerateButton } from "../../RegenerateButton";
import { Template } from "../../Template";

export const ResultsStep = () => {
  const analysis = useSelector(experienceAnalysis);

  return (
    <Template
      hideAbie={true}
      leftNode={<MessagePanel />}
      rightNode={
        <Grid
          container
          item
          justifyContent={"center"}
          flexWrap={"nowrap"}
          alignItems={"center"}
          columnSpacing={1}
        >
          <RegenerateButton />
          <Grid item sx={{ marginTop: "13px" }}>
            <BackButton
              disabled={
                !analysis.isMessageComplete && !analysis.isReadyForQuery
              }
            />
          </Grid>
        </Grid>
      }
    />
  );
};
